import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "../../../../components/ui/input";
import { Select } from "../../../../components/ui/select";
import { useBultos } from "../hooks/useBultos";
import { useCultivo } from "../hooks/useCultivo";
import { useEtiqueta } from "../hooks/useEtiqueta";
import { usePesoEnvase } from "../hooks/usePesoEnvase";
import { useTipoCaja } from "../hooks/useTipoCaja";
import { useTipoEtiqueta } from "../hooks/useTipoEtiqueta";
import { esEnteroMayorACero, handleChangeValue } from "../utils";

export const SugerenciaForm = ({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleSubmit,
  isLoading,
  onCancel,
}) => {
  const { cultivo } = useCultivo();
  const { tipoEtiqueta } = useTipoEtiqueta();
  const { pesoEnvase } = usePesoEnvase(values.cultivo_id);
  const { tipoCaja } = useTipoCaja(values.peso_envase_id);
  const { etiqueta } = useEtiqueta(
    values.tipo_caja_id,
    values.tipo_etiqueta_id,
  );
  const { bultos } = useBultos(values.tipo_caja_id);

  const handleOtroChange = (otro) => {
    if (esEnteroMayorACero(otro)) {
      setFieldValue("bultos", otro);
    } else {
      setFieldValue("bultos", "");
    }
  };

  const handleBultosChange = (palet_id) => {
    setFieldValue("palet_id", Number(palet_id));
    if (palet_id === 0) {
      setFieldValue("bultos", "");
    } else {
      const palet = bultos.find((item) => item.id_palet === Number(palet_id));
      setFieldValue("bultos", palet ? palet.palet : 0);
    }
  };

  return (
    <div
      className="d-flex flex-column flex-grow-1 gap-2 p-2 w-100"
      style={{ maxWidth: "30rem" }}
    >
      <label>
        Alias
        <Input
          value={values.alias}
          onChange={handleChange}
          name="alias"
          id="alias"
        />
      </label>

      <label>
        Cultivo
        <Select
          value={values.cultivo_id}
          onChange={(e) =>
            handleChangeValue(setFieldValue, "cultivo_id", e.target.value)
          }
          name="cultivo_id"
          id="cultivo_id"
          error={(errors.cultivo_id && touched.cultivo_id) !== undefined}
        >
          <option value={0}>Seleccionar...</option>
          {cultivo?.map((item) => (
            <option key={item.idcultivo} value={item.idcultivo}>
              {item.cultivo}
            </option>
          ))}
        </Select>
      </label>

      <label>
        Tipo etiqueta
        <Select
          value={values.tipo_etiqueta_id}
          onChange={(e) =>
            handleChangeValue(setFieldValue, "tipo_etiqueta_id", e.target.value)
          }
          name="tipo_etiqueta_id"
          id="tipo_etiqueta_id"
          error={
            (errors.tipo_etiqueta_id && touched.tipo_etiqueta_id) !== undefined
          }
        >
          <option>Seleccionar...</option>
          {tipoEtiqueta.map((item) => (
            <option key={item.idtipo_etiqueta} value={item.idtipo_etiqueta}>
              {item.etiqueta}
            </option>
          ))}
        </Select>
      </label>

      <label>
        Peso envase
        <Select
          value={values.peso_envase_id}
          onChange={(e) =>
            handleChangeValue(setFieldValue, "peso_envase_id", e.target.value)
          }
          name="peso_envase_id"
          id="peso_envase_id"
          error={
            (errors.peso_envase_id && touched.peso_envase_id) !== undefined
          }
        >
          <option value={0}>Seleccionar...</option>
          {values.cultivo_id !== 0 &&
            pesoEnvase.map((item) => (
              <option value={item.idtamano_envase} key={item.idtamano_envase}>
                {item.tamano}
              </option>
            ))}
        </Select>
      </label>

      <label>
        Tipo caja
        <Select
          value={values.tipo_caja_id}
          onChange={(e) =>
            handleChangeValue(setFieldValue, "tipo_caja_id", e.target.value)
          }
          name="tipo_caja_id"
          id="tipo_caja_id"
          error={(errors.tipo_caja_id && touched.tipo_caja_id) !== undefined}
        >
          <option value={0}>Seleccionar...</option>
          {values.peso_envase_id !== 0 &&
            tipoCaja.map((item) => (
              <option value={item.idenvase} key={item.idenvase}>
                {item.envase}
              </option>
            ))}
        </Select>
      </label>

      <label>
        Etiqueta
        <Select
          value={values.etiqueta_id}
          onChange={(e) =>
            handleChangeValue(setFieldValue, "etiqueta_id", e.target.value)
          }
          name="etiqueta_id"
          id="etiqueta_id"
          error={(errors.etiqueta_id && touched.etiqueta_id) !== undefined}
        >
          <option value={0}>Seleccionar...</option>
          {values.tipo_etiqueta_id !== 0 &&
            values.tipo_caja_id !== 0 &&
            etiqueta.map((item) => (
              <option value={item.idetiqueta} key={item.idrelacion}>
                {item.etiqueta}
              </option>
            ))}
        </Select>
      </label>

      <div className="d-flex flex-column flex-md-row gap-2">
        <label className="flex-grow-1">
          Bultos
          <Select
            value={values.palet_id}
            onChange={(e) => handleBultosChange(e.target.value)}
            name="palet_id"
            id="palet_id"
            error={(errors.palet_id && touched.palet_id) !== undefined}
          >
            <option value={0}>Seleccionar...</option>
            {values.tipo_caja_id !== 0 &&
              bultos.map((item) => (
                <option value={item.id_palet} key={item.id_palet}>
                  {item.palet}
                </option>
              ))}
          </Select>
        </label>

        {values.palet_id === 0 && (
          <label className="flex-grow-1">
            Otro
            <Input
              type="number"
              value={values.bultos}
              onChange={(e) => handleOtroChange(e.target.value)}
              id="bultos"
              name="bultos"
              error={(errors.bultos && touched.bultos) !== undefined}
              min={0}
            />
          </label>
        )}
      </div>

      <button
        className="btn btn-success"
        type="submit"
        onClick={handleSubmit}
        disabled={isLoading}
      >
        {isLoading && <FontAwesomeIcon icon="fa-solid fa-spinner" />}
        Guardar
      </button>
      <button className="btn btn-danger" onClick={onCancel}>
        Cancelar
      </button>
    </div>
  );
};
